<template>
  <div id="app">
    <v-app light>
      <!-- <home-component></home-component> -->
      <NavigationComponent v-if="$route.path.indexOf('admin') === -1"/>
      <DashBoardNav v-else/>
      <DashBoardNavDrawer v-if="$route.path.indexOf('admin') !== -1 && $route.path.indexOf('login') === -1"/>
      <div id="content">
        <router-view/>
      </div>
      <FooterComponent v-if="$route.path.indexOf('admin') === -1"/>
      <DashBoardFooter v-else/>
      <!-- <VideoPlayer v-if="isShowVideo" @hideVideo="isShowVideo=!isShowVideo"/>  -->
    </v-app>
  </div>
</template>

<script>
import NavigationComponent from '@/components/NavigationComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'
import DashBoardNav from '@/components/DashBoardNav'
import DashBoardFooter from '@/components/DashBoardFooter'
import DashBoardNavDrawer from '@/components/DashBoardNavDrawer'
import * as easings from 'vuetify/es5/util/easing-patterns'

export default {
  data () {
    return {
      // isShowVideo: false
      type: 'number',
      number: 300,
      duration: 1000,
      offset: 0,
      easing: 'easeInOutCubic',
      easings: Object.keys(easings)
    }
  },
  components: {
    NavigationComponent,
    FooterComponent,
    DashBoardNav,
    DashBoardFooter,
    DashBoardNavDrawer
  },
  watch: {
    $route: function () {
      if (this.$route.path === '/' || this.$route.path.indexOf('admin') !== -1) {
        this.$vuetify.goTo(0, this.options)
      } else {
        this.$vuetify.goTo(0, {duration: 500, offset: 0, easing: 'easeInOutCubic'})
        setTimeout(() => {
          this.$vuetify.goTo(this.target, this.options)
        }, 501)
      }
    }
  },
  computed: {
    target () {
      const value = this[this.type]
      if (!isNaN(value)) return Number(value)
      else return value
    },
    options () {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      }
    }
  }
  // methods: {
  //   showVideo () {
  //     this.isShowVideo = !this.isShowVideo
  //   }
  // }
}
</script>


<style>
#app {
  /*font-family: 'PT Serif', serif;*/
  /*font-family: 'Vollkorn', serif;*/
  font-family: 'Lato', sans-serif;
  background: #e6e6e6;
}
header {
  background-color: #212529;
}

#content {
  margin-top: 40px;
  padding-bottom: 115px; 
}

footer {
  width: 100%;
  height: 100px;
  position: absolute;
  padding-top: 44px;
  bottom: 0;
  left: 0;
  margin-bottom: -50px;
  background-color: #000000;
}

a {
  color: #b5b5b5;
  text-decoration: none;
}

.content-text {
  font-size: 12pt;
}
.buzz-hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.custom-fade-enter {
    opacity: 0
  }
  .custom-fade-enter-active {
    animation: fade-in .55s;
  }
  .custom-fade-leave,
  .custom-fade-leave-active {
    /*animation: fade-in .5s reverse;*/
    opacity: 0;
    display: none;
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 0.25;
    }
    50% {
      opacity: 0.5;
    }
    75% {
      opacity: 0.75;
    }
    100% {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue